
import {all, takeEvery, select, call, put } from '@redux-saga/core/effects';
import { invoicesBaseUrl, httpClient } from '../../http-client/http-client';
import { invoicesActions } from '../actions/invoices/invoices';
import actionTypes from '../actions/actionTypes';
import { planActions } from '../actions/plans/plans';

const accessTokenSelector = (state) => state.oidc.user.access_token;

function* fetch(action) {
  const accessToken = yield select(accessTokenSelector);
  const pageSize = yield select((state) => state.invoices.pageSize);
  const offset = yield select((state) => state.invoices.nextOffset);

  const url = `${invoicesBaseUrl}?pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(invoicesActions.fetchOk(data));
  }
  catch(error) {
    yield put(invoicesActions.fetchError(error));
  }
}

export function* watchInvoices() {
  yield all([
    takeEvery(actionTypes.invoices.FETCH, fetch),
    takeEvery(actionTypes.invoices.FETCH_MORE, fetch)
  ]);
};